import classNames from 'classnames';
import Icon, { IconProps } from '../Icon';

export interface Props {
  icon?: IconProps;
  text?: string;
  iconClass?: string;
  className?: string;
}
function Tag({ text, icon, className, iconClass }: Props) {
  return (
    <span
      className={classNames([
        'flex items-center gap-2',
        className
      ])}
    >
      {icon && (
        <Icon
          icon={icon as IconProps}
          className={classNames(iconClass)}
        />
      )}
      <span className="block whitespace-nowrap">
        {text}
      </span>
    </span>
  );
}

export default Tag;
